import { render, staticRenderFns } from "./BeefCattleDetailModal.vue?vue&type=template&id=76f00872"
import script from "./BeefCattleDetailModal.vue?vue&type=script&lang=js"
export * from "./BeefCattleDetailModal.vue?vue&type=script&lang=js"
import style0 from "./BeefCattleDetailModal.vue?vue&type=style&index=0&id=76f00872&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports